import EditorWrapper from './EditorWrapper';

export default EditorWrapper;
